var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStuName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1062 23.5C45.1062 36.0387 35.0089 46.2034 22.5532 46.2034C10.0975 46.2034 0.000213623 36.0387 0.000213623 23.5C0.000213623 10.9613 10.0975 0.796692 22.5532 0.796692C35.0089 0.796692 45.1062 10.9613 45.1062 23.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1743 17.4728C28.1743 21.4636 25.7636 24.8885 22.5536 24.8885C19.341 24.8885 16.9328 21.4636 16.9328 17.4716C16.9328 13.482 19.0062 11.1488 22.5536 11.1488C26.1009 11.1488 28.1743 13.4808 28.1743 17.4728ZM12.6885 33.8093C13.1694 34.3813 15.2403 36.13 22.5536 36.13C29.8668 36.13 31.9365 34.3813 32.4186 33.8105C32.4634 33.7557 32.4964 33.6922 32.5157 33.6242C32.5351 33.5561 32.5403 33.4847 32.5311 33.4146C32.4211 32.3129 31.4294 27.3866 22.5536 27.3866C13.6777 27.3866 12.686 32.3129 12.5748 33.4146C12.5658 33.4848 12.5712 33.5562 12.5907 33.6243C12.6103 33.6924 12.6435 33.7545 12.6885 33.8093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStuName);
export default __webpack_public_path__ + "static/media/stu-name.88c44d2d0aef08b5a1993622955a90c4.svg";
export { ForwardRef as ReactComponent };